_ = require('lodash')

ScoreDataHolderService = ->
  init: (round, ownerPlayer, fromJapan) ->
    @ownerPlayer = ownerPlayer
    @fromJapan = fromJapan
    @players = round?.players

    if round
      @club = round.club
      @roundInfo = _.pick round, 'id', 'course', 'course_extra', 'tee', 'tee_extra', 'holes', 'holes_extra', 'extra_9', 'play_date', 'weather', 'started_hole', 'round_type', 'has_extra'
      @roundInfo.extra_9 = true if round.round_type == 1.5
      @roundInfo.course.holes = @roundInfo.holes.length
      @roundInfo.course_extra.holes = @roundInfo.holes.length if @roundInfo.course_extra
      @club.courses = _.union(@club.courses, [@roundInfo.course])
      @club.courses = _.uniq(@club.courses)
      @editMode = true
    else
      @club = null
      @roundInfo = null

module.exports = ScoreDataHolderService



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/score-registration/score-data-holder-service.coffee